module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }